module.exports = __webpack_public_path__ + "img/drive_charge_off.a1399574.svg";